import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useLayout } from 'src/shared/hooks/useLayout';
import { useMembershipAdminMenu } from 'src/shared/hooks/useMembershipAdminMenu';
import * as styles from './floatingMenu.module.css';
const FloatingMenu = forwardRef(function FloatingMenu({ children, isVisible }, ref) {
    const { screenWidth } = useLayout();
    const membershipAdminMenu = useMembershipAdminMenu(screenWidth);
    return (_jsx("div", { children: _jsx("div", { ref: ref, className: clsx(styles.floatingMenu, 'transform rounded-large shadow-large transition-all duration-100 ease-out', isVisible ? 'scale-100 opacity-100' : 'scale-0 opacity-0'), style: { '--menu-left-offset': membershipAdminMenu.width }, children: _jsx("div", { className: "flex flex-col items-center justify-between gap-2 rounded-extralarge border-8 border-solid border-primary-600/10 border-opacity-10 bg-neutral-0 p-3 md:flex-row", children: children }) }) }));
});
export default FloatingMenu;
